// src/components/WorkoutDetails/WorkoutDetailsHeader.js
import React from "react";

const WorkoutDetailsHeader = ({ data }) => (
  <header className="workout-header-container">
    <span className="workout-line"></span>
    <h1 className="display-4 fw-bolder text-capitalize mb-2 hero-title">
      {data.titleBefore} <span className="text-color">{data.titleRed}</span> {data.titleAfter}
    </h1>
    <span className="workout-line"></span>
  </header>
);

export default WorkoutDetailsHeader;
